import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/OnboardsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, HiddenInput, MyReactSelect, MySelect, Text, TextEmail, TextFloat } from '../../inputs/inputs';
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getRequirements } from '../../../models/RequirementsModel';
import { getData as getCandidates } from '../../../models/CandidatesModel';

import AdminLayout from '../../layout/AdminLayout';
import { Helmet } from 'react-helmet';
import PageHeader from '../../common/PageHeader';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { QuickAdd } from '../../modals/QuickAdd';
import { checkPermission } from "../../../helpers/GeneralHelper";
import WorkflowHelpBanner from "../../common/WorkflowHelpBanner";
import HelpTooltip from "../../common/HelpTooltip";
import {
  buildSelectOption,
  buildOnboardCandidateListParams,
  buildInterviewLinkLabel,
  findCandidateById,
  findInterviewById,
  findOnboardByInterviewId,
  mapCandidateToOnboardPrefill,
  mapCandidateToOnboardIdentityPrefill,
  normalizeOnboardExperienceFields,
} from "../../../helpers/PipelineFilterHelper";
import {
  ONBOARD_PIPELINE_RULES,
  validatePipelineForm,
} from "../../../helpers/PipelineFormValidationHelper";
import * as candidateStatusModel from "../../../models/CandidateStatusModel";
import StatusSuggestionModal from "../../common/StatusSuggestionModal";
import {
  mapCandidateStatusOptions,
  resolveOnboardStatusSuggestion,
} from "../../../helpers/StatusAutomationHelper";

export const OnboardForm = () => {

  const location = useLocation();
  const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
  const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';
  const module = location.state?.module;
  const data = location.state?.data;
  const prefill = location.state?.prefill;

  const inputFields = {
    'onboard_client_id': '',
    'onboard_requirement_id': '',
    'onboard_candidate_id': '',
    'onboard_interview_id': '',
    'onboard_total_exp': '',
    'onboard_relevant_exp': '',
    'onboard_previous_employer': '',
    'onboard_notice_period': '',
    'onboard_can_join': '',
    'onboard_native': '',
    'onboard_previous_designation': '',
    'onboard_previous_ctc': '',
    'onboard_expected_ctc': '',
    'onboard_offered_ctc': '',
    'onboard_is_pf': '',
    'onboard_is_vendor': '',
    'onboard_vendor_email': '',
    'onboard_vendor_fee': '',
    'onboard_doj': '',
    'onboard_present_location': '',
    'onboard_work_location': '',
    'onboard_br_approved': '',
    'onboard_br_tax': '',
    'onboard_gpm': '',
    'onboard_gp_month': '',
    'onboard_sales_spoc': '',
    'onboard_business_unit': '',
    'onboard_account_manager': '',
    'onboard_account_coordinator': ''
  }

  const formatOptions = [
    {
      type: 'react-select',
      column: 'onboard_client_id',
      labelColumn: 'client_name'
    },
    {
      type: 'react-select',
      column: 'onboard_requirement_id',
      labelColumn: 'requirement_name'
    },
    {
      type: 'react-select',
      column: 'onboard_candidate_id',
      labelColumn: 'candidate_name'
    },
    {
      type: 'react-datepicker',
      column: 'onboard_doj',
    },
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [prefillApplied, setPrefillApplied] = useState(false);
  const [identityFromCandidate, setIdentityFromCandidate] = useState(false);
  const [showInternalSection, setShowInternalSection] = useState(false);
  const [linkedInterview, setLinkedInterview] = useState(null);
  const [existingLinkedOnboard, setExistingLinkedOnboard] = useState(null);
  const [candidateStatusOptions, setCandidateStatusOptions] = useState([]);
  const [statusSuggestion, setStatusSuggestion] = useState(null);
  const [showStatusSuggestion, setShowStatusSuggestion] = useState(false);
  const pendingAfterSuggestion = useRef(null);
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const optionsYesNo = [
    {value: 1, label: 'Yes' },
    {value: 0, label: 'No' },
  ];

  const optionsTax = [
    {value: 'Inclusive', label: 'Inclusive' },
    {value: 'Exclusive', label: 'Exclusive' },
  ];

  const [clients, setClients] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    const fetchCandidateStatuses = async () => {
      try {
        const response = await candidateStatusModel.getData({
          user_token: user_data.user_token,
          page: 1,
          limit: -1,
        });
        if (response?.candidate_status) {
          setCandidateStatusOptions(mapCandidateStatusOptions(response.candidate_status));
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCandidateStatuses();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      if (! fields.onboard_candidate_id) {
        fields.onboard_client_id = '';
        setRequirements([]);
        return;
      }
      var candidate_id = '';
      if(fields.onboard_candidate_id){
        candidate_id = fields.onboard_candidate_id.value;
      }
      try {
        const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1, candidate_id: candidate_id});
        if (! result) return;

        const clientOptions = result.clients.map(client => ({
          value: client._client_id,
          label: client.client_name
        }));

        setClients(clientOptions);
      } catch (error) {
        console.error(error);
      }
    };

    fetchClients();
  }, [fields.onboard_candidate_id]);

  const [loadingRequirements, setLoadingRequirements] = useState(false);
  useEffect(() => {
    const fetchRequirements = async() => {
      if (! fields.onboard_client_id) {
        fields.onboard_requirement_id = '';
        setRequirements([]);
        return;
      }

      var requirement_client_id = '';
      if (fields.onboard_client_id) {
        requirement_client_id = fields.onboard_client_id.value;
      }
      var candidate_id = '';
      if(fields.onboard_candidate_id){
        candidate_id = fields.onboard_candidate_id.value;
      }

      setLoadingRequirements(true);

      try {
        let apiParam = {user_token: user_data.user_token, 'requirement_client_id': requirement_client_id, page: 1, limit: -1, candidate_id: candidate_id};
        const response = await getRequirements(apiParam);

        if (typeof response != typeof undefined) {
          let options = [];
          let flag = false;
          response.requirements.forEach(function(item) {
            if (fields.onboard_requirement_id == item._requirement_id || fields.onboard_requirement_id?.value == item._requirement_id) {
              flag = true;
            }
            options.push({
              value: item._requirement_id,
              label: item.requirement_name
            });
          });

          if (! flag) {
            fields.onboard_requirement_id = '';
          }

          setRequirements(options);
        }
      } catch (error) {
        console.error(error);
      }

      setLoadingRequirements(false);
    }

    fetchRequirements();
  }, [fields.onboard_client_id, fields.onboard_candidate_id]);

  const [loadingCandidates, setLoadingCandidates] = useState(false);
  useEffect(() => {
    if (data) return;

    const fetchCandidates = async () => {
      setLoadingCandidates(true);

      try {
        const clientId = fields.onboard_client_id?.value;
        const requirementId = fields.onboard_requirement_id?.value;
        const response = await getCandidates(
          buildOnboardCandidateListParams(user_data.user_token, {
            clientId,
            requirementId,
          })
        );

        if (typeof response != typeof undefined) {
          let options = [];
          let flag = false;
          response.candidates.forEach(function (item) {
            if (
              fields.onboard_candidate_id == item._candidate_id ||
              fields.onboard_candidate_id?.value == item._candidate_id
            ) {
              flag = true;
            }
            options.push({
              value: item._candidate_id,
              label: `${item.candidate_firstname} ${item.candidate_lastname}`.trim(),
            });
          });

          if (!flag && fields.onboard_candidate_id && !prefillApplied) {
            setFields((prev) => ({ ...prev, onboard_candidate_id: "" }));
          }

          setCandidates(options);
        }
      } catch (error) {
        console.error(error);
      }

      setLoadingCandidates(false);
    };

    fetchCandidates();
  }, [
    data,
    fields.onboard_client_id,
    fields.onboard_requirement_id,
    prefillApplied,
    user_data.user_token,
  ]);

  useEffect(() => {
    if (data || isView) return;

    const candidateId = fields.onboard_candidate_id?.value;
    if (!candidateId) {
      setIdentityFromCandidate(false);
      return;
    }

    let cancelled = false;

    const syncIdentityFromCandidate = async () => {
      try {
        const candidate = await findCandidateById(user_data.user_token, candidateId);
        if (cancelled || !candidate) return;

        setFields((prev) => ({
          ...prev,
          ...mapCandidateToOnboardIdentityPrefill(candidate),
          onboard_candidate_id: prev.onboard_candidate_id,
        }));
        setIdentityFromCandidate(true);
      } catch (error) {
        console.error(error);
      }
    };

    syncIdentityFromCandidate();
    return () => {
      cancelled = true;
    };
  }, [fields.onboard_candidate_id?.value, data, isView, user_data.user_token]);

  useEffect(() => {
    if (data) {
      setId(data[module.primaryCol]);
      setFields(
        normalizeOnboardExperienceFields(
          formatDataBeforeDisplay(data, formatOptions)
        )
      );
      setErrors({});
    }

    const fetchSelectedSkills = async() => {
      if (! data?._onboard_id) {
        return;
      }

      try {
        const response = await model.getSelectedSkills(user_data.user_token, data._onboard_id);

        if (typeof response != typeof undefined) {
          let skills = [];
          response.data.skills.forEach(function(item) {
            skills.push({ value: item._skill_id, label: item.skill_name });
          });

          setFields((prev) => ({ ...prev, 'onboard_skills': skills }));
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchSelectedSkills();
  }, [data]);

  useEffect(() => {
    const interviewId =
      fields.onboard_interview_id ||
      data?.onboard_interview_id ||
      prefill?.interviewId;
    if (!interviewId || !user_data?.user_token) {
      if (!interviewId) {
        setLinkedInterview(null);
        if (!data) setExistingLinkedOnboard(null);
      }
      return;
    }

    let cancelled = false;

    const loadInterviewLink = async () => {
      try {
        const [interview, existingOnboard] = await Promise.all([
          findInterviewById(user_data.user_token, interviewId),
          !data ? findOnboardByInterviewId(user_data.user_token, interviewId) : Promise.resolve(null),
        ]);
        if (cancelled) return;
        setLinkedInterview(interview);
        if (!data) {
          setExistingLinkedOnboard(existingOnboard);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadInterviewLink();
    return () => {
      cancelled = true;
    };
  }, [
    fields.onboard_interview_id,
    data?.onboard_interview_id,
    data,
    prefill?.interviewId,
    user_data?.user_token,
  ]);

  useEffect(() => {
    if (data || prefillApplied || !prefill) return;

    const applyPrefill = async () => {
      if (prefill.interviewId) {
        setFields((prev) => ({
          ...prev,
          onboard_interview_id: prefill.interviewId,
        }));
      }

      if (prefill.candidateId) {
        const candidate = await findCandidateById(
          user_data.user_token,
          prefill.candidateId
        );
        if (candidate) {
          setFields((prev) => ({
            ...prev,
            ...mapCandidateToOnboardPrefill(candidate),
            onboard_interview_id:
              prefill.interviewId || prev.onboard_interview_id || "",
          }));
          setIdentityFromCandidate(true);
          setPrefillApplied(true);
          return;
        }
      }

      const patch = {};
      if (prefill.interviewId) {
        patch.onboard_interview_id = prefill.interviewId;
      }
      if (prefill.clientId) {
        patch.onboard_client_id = buildSelectOption(
          prefill.clientId,
          prefill.clientName
        );
      }
      if (prefill.requirementId) {
        patch.onboard_requirement_id = buildSelectOption(
          prefill.requirementId,
          prefill.requirementName
        );
      }
      if (Object.keys(patch).length) {
        setFields((prev) => ({ ...prev, ...patch }));
        setPrefillApplied(true);
      }
    };

    applyPrefill();
  }, [data, prefill, prefillApplied, user_data.user_token]);

  const validator = useRef(new SimpleReactValidator(validorSettings()));

  const finishCreateFlow = () => {
    setFields(inputFields);
  };

  const closeStatusSuggestion = () => {
    setShowStatusSuggestion(false);
    setStatusSuggestion(null);
    if (pendingAfterSuggestion.current) {
      pendingAfterSuggestion.current();
      pendingAfterSuggestion.current = null;
    }
  };

  const maybeOfferStatusSuggestion = async (formData) => {
    if (isEdit || isView || data) return false;

    const candidateId =
      formData.onboard_candidate_id ||
      fields.onboard_candidate_id?.value ||
      fields.onboard_candidate_id;

    if (!candidateId) return false;

    const candidate = await findCandidateById(user_data.user_token, candidateId);
    if (!candidate) return false;

    const suggestion = resolveOnboardStatusSuggestion({
      candidate,
      statusOptions: candidateStatusOptions,
    });

    if (!suggestion) return false;

    setStatusSuggestion({ suggestion, candidate });
    setShowStatusSuggestion(true);
    pendingAfterSuggestion.current = finishCreateFlow;
    return true;
  };

  const submit = async(e) => {
    e.preventDefault();

    if (interviewBlocked) {
      toast.error("An onboard is already linked to this interview.");
      return;
    }

    if (!isView) {
      const pipelineValidation = validatePipelineForm(fields, ONBOARD_PIPELINE_RULES);
      if (!pipelineValidation.valid) {
        setErrors((prev) => ({ ...prev, ...pipelineValidation.errors }));
        toast.error("Please fill all required fields.");
        return;
      }
    }

    validator.current.showMessages();
    if (!validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);

      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        model.saveToStorage(response.data[module.key], response.data.pagination);

        if (isEdit) {
          navigate('/' + module.route);
        } else {
          const offeredSuggestion = await maybeOfferStatusSuggestion(formData);
          if (!offeredSuggestion) {
            finishCreateFlow();
          }
        }
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data?.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  if (! module) {
    navigate('/onboards');
    return;
  }

  const identityReadOnly = !isView && !isEdit && identityFromCandidate;
  const mappingReadOnly = isView || identityReadOnly;
  const interviewBlocked = !data && existingLinkedOnboard;
  const interviewModule = {
    title: "Interviews",
    singularTitle: "Interview",
    key: "interviews",
    route: "interviews",
    primaryCol: "_interview_id",
  };

  return (
    <AdminLayout>
      <Helmet>
        <title>{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle} - Digital CMS</title>
      </Helmet>

      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell onboard-form-shell">
          <PageHeader module={module} />

          {!isView && <WorkflowHelpBanner stage="onboards" />}

          <form onSubmit={submit}>
            <div className="row">
              <div className="col-sm-9">
                <div className="card custom-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="card-title">{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle}</div>
                  </div>
                  <div className="card-body">
                    {/* Section 1 — Identity (from candidate) */}
                    <div className="onboard-form-section">
                      <div className="onboard-form-section-header">
                        <div>
                          <h6 className="onboard-form-section-title">
                            <span className="onboard-form-section-icon identity">
                              <i className="bi bi-person-badge" />
                            </span>
                            Candidate &amp; requirement
                          </h6>
                          <p className="onboard-form-section-sub">
                            Pulled from the candidate profile — both Contract to Hire and Fulltime requirements are supported.
                          </p>
                        </div>
                      </div>

                      {identityReadOnly && (
                        <div className="onboard-identity-note">
                          <i className="ri-information-line me-1" />
                          Profile fields below are filled from the selected candidate and are read-only. Change the candidate to refresh them.
                        </div>
                      )}

                      {(linkedInterview || fields.onboard_interview_id || data?.onboard_interview_id) && (
                        <div className={`onboard-interview-link-card mb-3${interviewBlocked ? " is-blocked" : ""}`}>
                          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                            <div>
                              <div className="fw-semibold text-primary small mb-1">
                                <i className="ri-link me-1" />
                                Linked interview
                              </div>
                              <div className="text-muted small">
                                {buildInterviewLinkLabel(linkedInterview)}
                              </div>
                            </div>
                            {linkedInterview?.interview_unique_id && (
                              <Link
                                to={`/interviews/${linkedInterview.interview_unique_id}/view`}
                                state={{ data: linkedInterview, module: interviewModule }}
                                className="btn btn-sm btn-outline-primary"
                              >
                                Open interview
                              </Link>
                            )}
                          </div>
                          {interviewBlocked && (
                            <div className="text-danger small mt-2">
                              An onboard already exists for this interview.{" "}
                              {existingLinkedOnboard?.onboard_unique_id && (
                                <Link
                                  to={`/onboards/${existingLinkedOnboard.onboard_unique_id}/view`}
                                  state={{
                                    data: existingLinkedOnboard,
                                    module,
                                  }}
                                >
                                  View existing onboard
                                </Link>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      <HiddenInput column="onboard_interview_id" fields={fields} setFields={setFields} errors={errors} />

                      <div className="row gy-2 onboard-form-section-body">
                        <div className="col-xl-4 mb-3">
                          <MyReactSelect
                            column="onboard_candidate_id"
                            label="Candidate"
                            options={candidates}
                            required={true}
                            fields={fields}
                            setFields={setFields}
                            errors={errors}
                            disabled={!isView ? loadingCandidates : isView}
                            validator={!isView ? validator : null}
                            rules={!isView ? "required" : ""}
                          />
                          <HelpTooltip text="Shows candidates for the selected requirement or client. C2H and FTE requirements both appear." />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MyReactSelect
                            column="onboard_client_id"
                            label="Client"
                            options={clients}
                            required={true}
                            fields={fields}
                            setFields={setFields}
                            errors={errors}
                            quickAddKey="clients"
                            quickAddSet={setQuickModals}
                            disabled={mappingReadOnly}
                            validator={!isView && !mappingReadOnly ? validator : null}
                            rules={!isView && !mappingReadOnly ? "required" : ""}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MyReactSelect
                            column="onboard_requirement_id"
                            label="Requirement"
                            options={requirements}
                            required={true}
                            fields={fields}
                            setFields={setFields}
                            errors={errors}
                            disabled={mappingReadOnly || (!isView && loadingRequirements)}
                            validator={!isView && !mappingReadOnly ? validator : null}
                            rules={!isView && !mappingReadOnly ? "required" : ""}
                          />
                        </div>

                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_total_exp" label="Years of Experience (Total)" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_relevant_exp" label="Years of Experience (Relevant)" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_previous_employer" label="Previous Employer" fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_notice_period" label="Notice Period" fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_native" label="Native" fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_previous_designation" label="Previous Designation" fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_previous_ctc" label="Previous CTC" fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_present_location" label="Present Location (City)" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView || identityReadOnly} />
                        </div>
                      </div>
                    </div>

                    {/* Section 2 — Compensation & joining */}
                    <div className="onboard-form-section">
                      <div className="onboard-form-section-header">
                        <div>
                          <h6 className="onboard-form-section-title">
                            <span className="onboard-form-section-icon compensation">
                              <i className="bi bi-cash-stack" />
                            </span>
                            Compensation &amp; joining
                          </h6>
                          <p className="onboard-form-section-sub">
                            Enter offer and joining details for this onboard.
                          </p>
                        </div>
                      </div>

                      <div className="row gy-2 onboard-form-section-body">
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_offered_ctc" label="Offered CTC" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_expected_ctc" label="Expected CTC" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MySelect column="onboard_can_join" label="Can Join?" options={optionsYesNo} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <DatePicker column="onboard_doj" label="Date of Joining" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_work_location" label="Work Location (City)" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MySelect column="onboard_is_pf" label="PF" options={optionsYesNo} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                      </div>
                    </div>

                    {/* Section 3 — Internal / vendor (collapsed by default on create) */}
                    <div className={`onboard-form-section${!showInternalSection && !isView && !isEdit ? " is-collapsed" : ""}`}>
                      <div className="onboard-form-section-header">
                        <div>
                          <h6 className="onboard-form-section-title">
                            <span className="onboard-form-section-icon internal">
                              <i className="bi bi-building-gear" />
                            </span>
                            Internal &amp; vendor details
                          </h6>
                          <p className="onboard-form-section-sub">
                            Bill rate, GP, account team, and vendor information.
                          </p>
                        </div>
                        {!isView && !isEdit && (
                          <button
                            type="button"
                            className="btn btn-sm btn-light"
                            onClick={() => setShowInternalSection((prev) => !prev)}
                          >
                            <i className={`ri-arrow-${showInternalSection ? "up" : "down"}-s-line me-1`} />
                            {showInternalSection ? "Hide" : "Show"}
                          </button>
                        )}
                      </div>

                      <div className="row gy-2 onboard-form-section-body">
                        <div className="col-xl-4 mb-3">
                          <MySelect column="onboard_is_vendor" label="Vendor" options={optionsYesNo} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3" style={{ display: fields?.onboard_is_vendor == 1 ? "block" : "none" }}>
                          <TextEmail column="onboard_vendor_email" label="Vendor Email" fields={fields} setFields={setFields} errors={errors} validator={fields?.onboard_is_vendor == 1 ? validator : null} rules={fields?.onboard_is_vendor == 1 ? 'email' : ''} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3" style={{ display: fields?.onboard_is_vendor == 1 ? "block" : "none" }}>
                          <TextFloat column="onboard_vendor_fee" label="Vendor Fee" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MySelect column="onboard_br_approved" label="BR Approved? (p.m)" options={optionsYesNo} firstOption="Select BR approved" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <MySelect column="onboard_br_tax" label="BR Tax" options={optionsTax} firstOption="Select BR tax" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_gpm" label="GPM over Bill Rate (%)" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <TextFloat column="onboard_gp_month" label="GP per Month" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_sales_spoc" label="Sales Spoc" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_business_unit" label="Business Unit" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_account_manager" label="Account Manager" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Text column="onboard_account_coordinator" label="Account Coordinator" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-3">
                  <div className="card custom-card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                      { (isView && checkPermission(module.route, 'edit')) ? 
                      
                      <a
                        className="btn btn-icon btn-sm btn-info"
                        title="Edit"
                        onClick={() => navigate(`/onboards/${data.onboard_unique_id}/edit`,{ 
                          state: {
                            data: data,
                            module: module,
                          },
                        })} // Navigate to the edit page
                      >
                        <i className='bx bxs-edit'></i>
                      </a> :
                        <div>
                        <button className="btn btn-primary btn-md" disabled={loading || interviewBlocked}>
                          {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Save'}
                        </button>
                      </div>}

                      <div className="d-flex flex-wrap gap-2">
                        
                        <Link className="btn btn-light btn-sm float-end" to="/onboards">
                          <i className="bi bi-reply me-1 fw-semibold"></i> Back
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      
                    </div>
                  </div>
              </div>
            </div>
          </form>
          
        </div>
      </div>

      <QuickAdd title="Client" modalKey="clients" column="onboard_client_id" setFieldOptions={setClients} showModal={quickModals.clients} form={quickAddClient} setShowModal={setQuickModals} fields={fields} setFields={setFields} />

      <StatusSuggestionModal
        show={showStatusSuggestion}
        onHide={closeStatusSuggestion}
        suggestion={statusSuggestion?.suggestion}
        candidate={statusSuggestion?.candidate}
        userToken={user_data.user_token}
      />

      <Helmet></Helmet>
    </AdminLayout>
  );
};
